import axios from 'axios'
import qs from 'qs'

export const participantService = ({
  getParticipantList (token, groupId) {
    return axios.get('/api/GroupCourseCohort/Participants?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getParticipantListUsingGroupId (token, groupId, pageNo = 0, count = 0, searchString = '') {
    return axios.get(`/api/GroupCourseCohort/Participants?groupId=${groupId}&page=${pageNo}&count=${count}&search=${encodeURIComponent(searchString)}`, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createSingleParticipant (token, formDataObj) {
    return axios.post('/api/User/Create', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  enrollParticipant (token, userId, cohortId, isFacilitator) {
    var enrollmentObj = { UserId: userId, CohortId: cohortId, IsFacilitator: isFacilitator }
    var stringifiedObj = qs.stringify(enrollmentObj)
    return axios.post('/api/EnrollUser/EnrollSingleUser', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getUserProfile (token) {
    return axios.get('/api/UserProfile', {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAllParticipantList (token) {
    return axios.get('/api/Users', {headers: {'Authorization': 'Bearer ' + token}})
  },
  getMinParticipantList (token) {
    return axios.get('/api/User/MinInfo', {headers: {'Authorization': 'Bearer ' + token}})
  },
  getParticipantListUsingCohortId (token, cohortId) {
    return axios.get('/api/GroupCourseCohort/Users?cohortId=' + cohortId + '&showcert=true', {headers: {'Authorization': 'Bearer ' + token}})
  },
  unEnrollParticipant (token, userId, cohortId) {
    var unEnrollmentObj = { UserId: userId, CohortId: cohortId }
    var stringifiedObj = qs.stringify(unEnrollmentObj)
    return axios.put('/api/EnrollUser/UnEnrollSingleUser?unenroll=true', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  changeAllowToolkitFlag (token, userId, cohortId, allowToolkit) {
    var obj = { UserId: userId, CohortId: cohortId }
    var stringifiedObj = qs.stringify(obj)
    return axios.put('/api/EnrollUser/AllowToolkit?allowToolkit=' + allowToolkit, stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  changeAllowCourseFlag (token, userId, cohortId, allowCourse) {
    var obj = { UserId: userId, CohortId: cohortId }
    var stringifiedObj = qs.stringify(obj)
    return axios.put('/api/UserCohort/ToggleAllowed?allowed=' + allowCourse, stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  allowToolkitForAll (token, cohortId, userIdArr, allowed) {
    var obj = { CohortId: cohortId, AllowToolkit: allowed, UserIds: userIdArr }
    return axios.put('/api/EnrollUser/AllowToolkitForAll', obj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  allowCourseForAll (token, cohortId, userIdArr, allowed) {
    var obj = { CohortId: cohortId, Allowed: allowed, UserIds: userIdArr }
    // var stringifiedObj = qs.stringify(obj)
    return axios.put('/api/EnrollUser/ToggleCourseForAll', obj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  resetParticipantInfo (token, userId, cohortId, groupCourseMasterId, softReset) {
    var obj = { UserId: userId, CohortId: cohortId, GroupCourseMasterId: groupCourseMasterId, SoftReset: softReset }
    var stringifiedObj = qs.stringify(obj)
    // return axios.put('/api/EnrollUser/ResetUserCourse', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
    return axios.post('/api/UserCourse/ResetUserCourseData', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  hardResetParticipantInfo (token, userId) {
    return axios.put('/api/User/ResetUserData?userId=' + userId, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  enrollMultipleParticipantUsingCSV (token, cohortId, groupId, formDataObj) {
    return axios.post('/api/EnrollUser/UploadUserCSV?cohortId=' + cohortId + '&groupId=' + groupId, formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  unEnrollMultipleParticipantUsingCSV (token, cohortId, groupId, formDataObj) {
    return axios.put('/api/EnrollUser/UnEnrollUsers?cohortId=' + cohortId + '&groupId=' + groupId, formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  enrollMultipleParticipantUsingGCCCSV (token, formDataObj) {
    return axios.post('/api/EnrollUser/UploadUserCSV2', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  userEnrollments (token, userId) {
    return axios.get('/api/User/Enrollments?userId=' + userId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  UpdateParticipant (token, formDataObj) {
    return axios.put('/api/User/Update', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  participantActivity (token, startTS, endTS, userId) {
    var obj = { StartTS: startTS, EndTS: endTS, UserId: userId }
    var stringifiedObj = qs.stringify(obj)
    return axios.post('/api/user/activity', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteParticipant (token, userId) {
    return axios.delete('/api/User/Delete?userId=' + userId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  resetUserMeetingMentor (token, userId) {
    return axios.put('/api/User/ResetUserMeetingMentorData?userId=' + userId, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateUserProfile (token, userObj) {
    var stringifiedObj = qs.stringify(userObj)
    return axios.put('/api/UserProfile', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateUserPassword (token, userObj) {
    var stringifiedObj = qs.stringify(userObj)
    return axios.put('/api/UserProfile/ChangePassword', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  UpdateProfileImg (token, formDataObj) {
    return axios.post('/api/UserProfile/Picture', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  unEnrollMultipleParticipant (token, userIdArr, cohortId) {
    return axios.put('/api/EnrollUser/UnEnrollMultipleUsers?cohortId=' + cohortId, userIdArr, {headers: {'Authorization': 'Bearer ' + token}})
  },
  enrollMultipleParticipant (token, userIdArr, cohortId) {
    return axios.put('/api/EnrollUser/EnrollMultipleUsers?cohortId=' + cohortId, userIdArr, {headers: {'Authorization': 'Bearer ' + token}})
  },
  sendUserRequest (token, userObj) {
    var stringifiedObj = qs.stringify(userObj)
    return axios.post('/api/UserRequest', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAllParticipantListForPagination (token, pageNo = 0, count = 0, searchString = '', groupId = null) {
    return axios.get(`/api/Users?page=${pageNo}&count=${count}&search=${encodeURIComponent(searchString)}&groupId=${groupId}`, {headers: {'Authorization': 'Bearer ' + token}})
  },
  completeUserCourse (token, formDataObj) {
    return axios.post('/api/UserCohort/Complete', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateUserViewCertificate (token, cohortId, viewCertificate, userIdArr) {
    return axios.put('/api/EnrollUser/ToggleViewCertificate?cohortId=' + cohortId + '&viewcertificate=' + viewCertificate, userIdArr, {headers: {'Authorization': 'Bearer ' + token}})
  },
  generateUserCertificateAtGroup (token, userId, groupId, certificateId) {
    if (certificateId !== undefined && certificateId !== 'undefined' && certificateId !== null && certificateId !== 'null' && certificateId !== '') {
      return axios.post('/api/UserCertificate/UserCertificateForGroupV2?userId=' + userId + '&groupId=' + groupId + '&certificateId=' + certificateId, null, {headers: {'Authorization': 'Bearer ' + token}})
    } else {
      return axios.post('/api/UserCertificate/AllUserCertificatesForGroupV2?userId=' + userId + '&groupId=' + groupId, null, {headers: {'Authorization': 'Bearer ' + token}})
    }
  },
  updateViewCertificateStateAtGroup (token, groupId, viewCertificate, userId) {
    return axios.put('/api/UserCertificate/AllowGroupLevelCertificate?groupId=' + groupId + '&userId=' + userId + '&allowView=' + viewCertificate, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateViewCertificateStateAtGroupV2 (token, userCertificateId, viewCertificate) {
    return axios.put('/api/UserCertificate/AllowGroupLevelCertificateV2?userCertificateId=' + userCertificateId + '&allowView=' + viewCertificate, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  generateUserCertificateAtGroupCourse (token, userId, groupCourseId, cohortId) {
    return axios.post('/api/UserCertificate/UserCertificateForGCC?userId=' + userId + '&groupCourseId=' + groupCourseId + '&cohortId=' + cohortId, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getUserErrorStatus (token) {
    return axios.get('/api/User/ErrorStatus', {headers: {'Authorization': 'Bearer ' + token}})
  },
  logoutFromOtherDevices (token, currentPlatform) {
    return axios.post('/api/User/LogoutFromOtherDevices?currentPlatform=' + currentPlatform, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateLogoutForPlatform (token, currentPlatform) {
    return axios.put('/api/User/UpdateLogoutForPlatform?currentPlatform=' + currentPlatform, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAttachedCertificateToGroup (token, groupId) {
    return axios.get('/api/GroupCertificate/ListCertificatesByGroup?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getUserFullName (token, userIdArr) {
    return axios.post('api/User/UsersFullName', userIdArr, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/participant-service.js